"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var baseProps_1 = require("./baseProps");

exports.inputAttrs = function (props) {
  var autoFocus = props.autoFocus,
      name = props.name,
      defaultValue = props.defaultValue,
      value = props.value,
      onBlur = props.onBlur,
      onFocus = props.onFocus,
      onInput = props.onInput,
      onChange = props.onChange,
      onPaste = props.onPaste,
      onKeyDown = props.onKeyDown,
      placeholder = props.placeholder,
      disabled = props.disabled,
      required = props.required,
      autoCapitalize = props.autoCapitalize,
      autoComplete = props.autoComplete,
      autoCorrect = props.autoCorrect,
      maxLength = props.maxLength,
      spellCheck = props.spellCheck,
      ref = props.inputRef;
  return __assign({
    autoFocus: autoFocus,
    name: name,
    defaultValue: defaultValue,
    value: value,
    onBlur: onBlur,
    onFocus: onFocus,
    onInput: onInput,
    onChange: onChange && function (e) {
      return onChange(e.target.value);
    },
    onPaste: onPaste,
    onKeyDown: onKeyDown,
    placeholder: placeholder,
    disabled: disabled,
    required: required,
    autoCapitalize: autoCapitalize,
    autoComplete: autoComplete,
    autoCorrect: autoCorrect,
    spellCheck: spellCheck,
    maxLength: maxLength,
    ref: ref
  }, baseProps_1.default(props));
};